"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INITIATIVES_TABLE_DATA_INDICES = void 0;
exports.INITIATIVES_TABLE_DATA_INDICES = {
    ASSIGNED_TO: 'assignedTo',
    CREATED_ON: 'createdOn',
    STATUS_ID: 'initiativeStatusId',
    TITLE: 'title',
    TYPE_ID: 'initiativeTypeId'
};
//# sourceMappingURL=INITIATIVES_TABLE_DATA_INDICES.js.map